import { render, staticRenderFns } from "./TherapyPasswordResetRequest.vue?vue&type=template&id=5ac8191a"
import script from "./TherapyPasswordResetRequest.vue?vue&type=script&lang=js"
export * from "./TherapyPasswordResetRequest.vue?vue&type=script&lang=js"
import style0 from "./TherapyPasswordResetRequest.vue?vue&type=style&index=0&id=5ac8191a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports